import script from "./LoginCallback.vue?vue&type=script&lang=js"
export * from "./LoginCallback.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__